import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { unacknowledgedLevelItemResourceType } from "./unacknowledgedLevelResourceConsts";

export const unacknowledgedLevelItemIdentifierStruct = createIdentifierStruct(
  unacknowledgedLevelItemResourceType
);
